import type { LayerSpecification } from "maplibre-gl";

import { SOURCES } from "../sources";
import { LAYERS } from "./constants";

export const silos: LayerSpecification = {
  id: LAYERS.SILOS,
  type: "symbol",
  source: SOURCES.STATIONS,
  filter: ["==", ["coalesce", ["get", "entity_type"], "not_set"], "not_set"],
  layout: {
    "icon-image": [
      "concat",
      ["coalesce", ["get", "icon"], ["get", "type"], "ship"],
      "-",
      [
        "case",
        ["boolean", ["get", "isSelected"], false],
        "selected",
        "deselected",
      ],
    ],
    // 🌟 REVERTED: Dropped the dynamic expression. Locked to a static 0.35 layout scale.
    "icon-size": 0.35,
    "icon-rotate": ["get", "heading_deg"],
    "icon-rotation-alignment": "map",
    "icon-allow-overlap": true,
    "icon-ignore-placement": true,
    "text-field": [
      "format",
      ["get", "name"],
      { "font-scale": 0.9 },
      "\n",
      ["concat", "CAP: ", ["to-string", ["get", "capacity"]]],
      { "font-scale": 0.75 },
      "\n",
      ["concat", "INV: ", ["to-string", ["get", "inventory"]]],
      { "font-scale": 0.75 },
    ],
    "text-font": ["IBM Plex Mono Regular"],
    "text-anchor": [
      "case",
      [">", ["get", "heading_deg"], 180],
      "left",
      "right",
    ],
    "text-justify": [
      "case",
      [">", ["get", "heading_deg"], 180],
      "left",
      "right",
    ],
    // 🌟 UPDATED: Pushed out from 1.8 to 2.2 to give the icon breathing room
    "text-radial-offset": 2.2,
    "text-rotation-alignment": "map",
    "text-allow-overlap": true,
    "text-ignore-placement": true,
  },
  paint: {
    "text-color": [
      "case",
      ["boolean", ["get", "isSelected"], false],
      "#FFEBB3", // 🌟 UPDATED: Soft, desaturated champagne gold selection color
      "#F5F5F5", // Clean, high-visibility white for unselected states
    ],
    "text-halo-color": "#101012",
    "text-halo-width": 4,
    "text-halo-blur": 1.0,
  },
};
